import { useState } from "react";
import { Label } from "@/components/ui/label";
import { X } from "lucide-react";
import { toast } from "sonner";

export function RecipientField({ label, value, setValue, team, people = [], testId }) {
  const [input, setInput] = useState("");
  const add = (raw) => {
    const em = (raw || "").trim().toLowerCase().replace(/,$/, "");
    if (!em) return;
    if (!/^\S+@\S+\.\S+$/.test(em)) { toast.error(`Ongeldig e-mailadres: ${em}`); return; }
    if (!value.includes(em)) setValue([...value, em]);
    setInput("");
  };
  const peopleLeft = people.filter((p) => p.email && !value.includes(p.email.toLowerCase()));
  const teamLeft = team.filter((m) => !value.includes(m.email));
  return (
    <div className="space-y-1">
      <Label className="text-xs">{label}</Label>
      <div className="flex flex-wrap items-center gap-1.5 rounded-md border border-slate-200 px-2 py-1.5 bg-white">
        {value.map((em) => (
          <span key={em} data-testid={`${testId}-chip-${em}`} className="inline-flex items-center gap-1 rounded-full bg-slate-100 border border-slate-200 px-2 py-0.5 text-xs text-slate-700">
            {em}<button onClick={() => setValue(value.filter((x) => x !== em))} className="text-slate-400 hover:text-red-500"><X className="h-3 w-3" /></button>
          </span>
        ))}
        <input value={input} onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(input); } }}
          onBlur={() => input && add(input)}
          placeholder="e-mailadres + Enter" data-testid={`${testId}-input`}
          className="flex-1 min-w-[9rem] text-sm outline-none bg-transparent py-0.5" />
      </div>
      {(peopleLeft.length > 0 || teamLeft.length > 0) && (
        <div className="flex flex-wrap gap-1 pt-0.5">
          {peopleLeft.map((p) => (
            <button key={p.email} type="button" onClick={() => setValue([...value, p.email.toLowerCase()])}
              data-testid={`${testId}-person-${p.email}`} title={`${p.name || p.email} — extra deelnemer uit het dossier`}
              className="rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[11px] text-emerald-700 hover:bg-emerald-100 transition-colors">
              + {(p.name || p.email).split(" ")[0]}
            </button>
          ))}
          {teamLeft.map((m) => (
            <button key={m.email} type="button" onClick={() => setValue([...value, m.email])} data-testid={`${testId}-team-${m.email}`}
              className="rounded-full border border-blue-200 bg-blue-50 px-2 py-0.5 text-[11px] text-blue-700 hover:bg-blue-100 transition-colors">
              + {(m.name || m.email).split(" ")[0]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
